import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { partDetailsBatchConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const PartDetailsBatchStack = createStackNavigator();

const PartDetailsBatchNavigator = () => {
  return (
    <PartDetailsBatchStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {partDetailsBatchConfig.map(({ Component, name }) => (
        <PartDetailsBatchStack.Screen key={name} name={name} component={Component} />
      ))}
    </PartDetailsBatchStack.Navigator>
  );
};

export { PartDetailsBatchNavigator };
